(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'ROLES'];

    function stateConfig($stateProvider, ROLES) {
        $stateProvider
            .state('rcopia-account', {
                parent: 'entity',
                url: '/rcopia-account',
                data: {
                    authorities: [ROLES.ROLE_SYSTEM_ADMIN, ROLES.ROLE_SYSTEM],
                    pageTitle: 'Rcopia - Accounts'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/rcopia-account/list/rcopia-account.html',
                        controller: 'RcopiaAccountController',
                        controllerAs: 'vm'
                    }
                },
            });
    }
})();
